import {
  IconContent,
  IconFilters,
  IconHistory,
  IconNavi,
} from "@/components/IconFont";
import useTranslation from "@/hooks/useTranslation";
import React from "react";
import Block from "./Block";
import Display from "./Display";
import Feature from "./Feature";
import Filter from "./Filter";
import History from "./History";
import styles from "./styles.module.less";

const { container } = styles;

const SideBar: React.FC = () => {
  const { t } = useTranslation("explore");

  return (
    <div className={container}>
      <Block Icon={<IconNavi />} title={t("navi.navi")} Content={<Feature />} />
      <Block
        Icon={<IconFilters />}
        title={t("pubmed.sidebar.filter")}
        Content={<Filter />}
      />
      <Block
        Icon={<IconContent />}
        title={t("pubmed.sidebar.display.itself")}
        Content={<Display />}
      />
      <Block
        Icon={<IconHistory />}
        title={t("pubmed.sidebar.recent-activity")}
        Content={<History />}
      />
    </div>
  );
};

export default SideBar;
